<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolHealthManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "Clinic Records",
                description: "Record and review visits to the school clinic.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Medical History",
                description: "Maintain student medical histories and health notes.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Medication",
                description: "Track medications administered or recorded by the school.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Immunization",
                description: "Maintain student immunization records and schedules.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Emergency Reports",
                description: "Document health emergencies and actions taken.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
